import DynamicLegend from './dynamicLegend'
export default DynamicLegend
